// extracted by mini-css-extract-plugin
export default {"sidebar_logo":"sidebar-logo_sidebar_logo__zC3S0","sidebar_logo__icon":"sidebar-logo_sidebar_logo__icon__K7vre","sidebar_logo__title":"sidebar-logo_sidebar_logo__title__qw+6e"};